export const PlaceholderIcon: React.FC = () => (
  <div className='contents'>
    <div className="w-16 h-16">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <rect x="1.5" y="1.5" width="21" height="21" fill="none" stroke="#6b7280" strokeWidth="1.2"/>
        <line x1="4" y1="4" x2="20" y2="20" stroke="#6b7280" strokeWidth="1.2"/>
        <line x1="4" y1="20" x2="20" y2="4" stroke="#6b7280" strokeWidth="1.2"/>
      </svg>
    </div>
    <p className='text-xs text-gray-500'>Sin aviso de privacidad</p>
  </div>
);